module.exports = __webpack_public_path__ + "img/xiran-jay-zhao.084a308a.png";